import { esDO } from './es-DO';

const overrides: Partial<typeof esDO> = {
  // Common
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.create': 'Create',
  'common.search': 'Search',
  'common.loading': 'Loading…',
  'common.confirm': 'Confirm',
  'common.close': 'Close',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.yes': 'Yes',
  'common.no': 'No',

  // Navigation
  'nav.dashboard': 'Dashboard',
  'nav.properties': 'Properties',
  'nav.leads': 'Leads',
  'nav.crm': 'CRM',
  'nav.marketing': 'Marketing',
  'nav.reports': 'Reports',
  'nav.settings': 'Settings',
  'nav.billing': 'Billing',
  'nav.logout': 'Log out',

  // Properties
  'properties.title': 'Properties',
  'properties.create': 'Create property',
  'properties.type.apartment': 'Apartment',
  'properties.type.house': 'House',
  'properties.type.land': 'Land',
  'properties.type.commercial': 'Commercial',
  'properties.type.vacation_rental': 'Vacation rental',

  // Leads
  'leads.title': 'Leads',
  'leads.stage.new': 'New',
  'leads.stage.contacted': 'Contacted',
  'leads.stage.qualified': 'Qualified',
  'leads.stage.negotiation': 'Negotiation',
  'leads.stage.closed_won': 'Won',
  'leads.stage.closed_lost': 'Lost',

  // Billing
  'billing.subscription': 'Subscription',
  'billing.plan': 'Plan',
  'billing.addons': 'Add-ons',
  'billing.invoices': 'Invoices',
  'billing.upgrade': 'Upgrade plan',
  'billing.cancel': 'Cancel subscription',

  // Errors
  'error.unknown': 'An unexpected error occurred',
  'error.network': 'Network error. Check your connection.',
  'error.unauthorized': 'Unauthorized',
  'error.forbidden': 'You do not have permission for this action',
  'error.not_found': 'Not found',

  // Success
  'success.saved': 'Saved successfully',
  'success.deleted': 'Deleted successfully',
  'success.created': 'Created successfully',
};

export const enUS = { ...esDO, ...overrides };
